export * from 'utils/clientUtils.js';

export function getDesktop(str) {
	if (!str || typeof str !== 'string') {
		return false;
	} else {
		return str.includes('esktop');
	}
}
